// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { SDK_VERSION } from "../constants.js";
import { createTracingClient } from "@azure/core-tracing";
/**
 * Creates a span using the global tracer.
 * @internal
 */
export const tracingClient = createTracingClient({
    namespace: "Microsoft.AAD",
    packageName: "@azure/identity",
    packageVersion: SDK_VERSION,
});
//# sourceMappingURL=tracing.js.map